@if (buttonText) {
  <button
    class="text-white text-sm lg:text-base xl:text-lg flex items-center gap-2 px-3 md:px-4 h-9 lg:h-10 xl:h-11 rounded font-semibold cursor-pointer group bg-gradient-to-r from-(--primary) to-(--secondary) hover:bg-gradient-to-l transition-all"
    (click)="onClick()"
  >
    {{ buttonText }}
    <img
      class="w-3 lg:w-4 h-auto relative group-hover:translate-x-1 transition-all"
      src="assets/icons/right-arrow.svg"
      alt="Right Arrow"
      height="16"
      width="16"
      loading="eager"
    />
  </button>
}
